module.exports = __webpack_public_path__ + "img/contributions30Off.dda2811c.svg";